<template>
  <div>
    <div v-if="isLoading">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex">
          <base-skeleton-loader class="tw-h-4 tw-w-5 tw-mt-0.5" />
          <div class="tw-ml-3 tw-text-sm">
            <base-skeleton-loader class="tw-h-3 tw-mb-1.5 tw-mt-0.5 tw-w-10" />
            <base-skeleton-loader class="tw-h-2 tw-my-1 tw-w-8 tw-mt-2.5" />
          </div>
        </div>
        <base-skeleton-loader class="tw-h-3 tw-w-10 tw-mr-2" />
      </div>
    </div>
    <div class="tw-flex tw-justify-between tw-items-center" v-else>
      <div class="tw-flex">
        <credit-card-icon class="tw-w-8 tw-h-8 tw-my-auto" :name="savedCreditCard.brand" />
        <div class="tw-ml-3 tw-text-sm" v-if="savedCreditCard.last4">
          <div>**** {{ savedCreditCard.last4 }}</div>
          <div class="tw-text-gray-500 tw-text-xs">Exp {{ expDate }}</div>
        </div>
        <div class="tw-ml-3 tw-my-auto tw-text-gray-500" v-else>No Card</div>
      </div>
      <base-button type="flat" size="xs" @click="$emit('update:isUpdating', !isUpdating)">{{ isUpdating ? "Cancel" : "Update" }}</base-button>
    </div>
  </div>
</template>

<script>
import { padStart } from "lodash";
import CreditCardIcon from "@/components/CreditCardIcon";

export default {
  components: {
    CreditCardIcon,
  },
  props: {
    userId: String,
    businessId: String,
    userBusinessPlanId: String,
    isUpdating: Boolean,
  },
  data() {
    return {
      isLoading: true,
      savedCreditCard: null,
    };
  },
  computed: {
    hasSavedCreditCard() {
      return !!this.savedCreditCard && !!this.savedCreditCard.last4;
    },
    expDate() {
      if (this.savedCreditCard) {
        return `${padStart(this.savedCreditCard.expMonth, 2, "0")} / ${this.savedCreditCard.expYear.toString().slice(-2)}`;
      }
      return "";
    },
  },
  created() {
    this.getCard();
  },
  methods: {
    async getCard() {
      try {
        this.isLoading = true;

        let url;

        if (this.businessId && !this.userId && !this.userBusinessPlanId) {
          //business CC
          url = `/businesses/${this.businessId}/creditcard`;
        } else if (this.businessId && this.userId && this.userBusinessPlanId) {
          //business user card
          url = `/businesses/${this.businessId}/members/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;
        } else if (this.userId && !this.businessId && !this.userBusinessPlanId) {
          //user cards
          url = `/users/${this.userId}/creditcard`;
        } else if (this.userId && this.userBusinessPlanId && !this.businessId) {
          url = `/users/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;
        }
        const response = await this.$axios.get(url);
        this.savedCreditCard = response.data;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
